import { PDFTextField } from "pdf-lib";
import { getWidgetRectangle } from "components/Forms/utils/pdfFieldGeometry";
import { getWidgetBorderWidth, parseDefaultAppearance } from "components/Forms/utils/pdfTextFitting";
import { getRuledTextBox, getRuledTextareaStyle } from "components/Forms/utils/pdfRuledFields";

// `ruledLayout` (ver pdfRuledFields) pone el texto de los campos con renglones sobre cada renglón.
export const processField = (pages, field, pdfScale, pdfWidth, ruledLayout = null) => {
    const fieldData = [];
    const widgets = field.acroField.getWidgets();

    widgets.forEach((widget) => {
        // 5. Encontrar la página en la que está el widget
        const pageIndex = pages.findIndex((p) => p.ref === widget.P());
        const page = pages[pageIndex];
        // Un widget sin /P resoluble no se puede ubicar en ninguna pagina; se omite
        // en lugar de reventar al pedirle el tamano a un `undefined`.
        if (!page) return;
        const { width: pageWidth, height: pageHeight } = page.getSize();

        const scale = (pdfScale * pdfWidth) / pageWidth;

        // 6. Obtener el rectángulo de posición del widget
        // Normalizado: hay widgets con el /Rect invertido y getRectangle() los
        // devuelve con alto negativo. Ver getWidgetRectangle.
        const rect = getWidgetRectangle(widget);

        if (field instanceof PDFTextField && field.isCombed()) {
            const maxLen = field.getMaxLength();
            if (maxLen > 0) {
                const cellWidth = rect.width / maxLen; // Ancho de cada casilla individual
                const combedFieldData = [];
                // Calculamos las coordenadas para cada una de las casillas
                for (let i = 0; i < maxLen; i++) {
                    const cellRect = {
                        x: rect.x + i * cellWidth,
                        y: rect.y,
                        width: cellWidth,
                        height: rect.height,
                    };

                    const cssTop = pageHeight - cellRect.y - cellRect.height;
                    const cssLeft = cellRect.x;

                    combedFieldData.push({
                        pageIndex,
                        isCell: true, // Propiedad para identificar que es una celda
                        cellIndex: i,
                        pdfCoords: cellRect,
                        cssCoords: {
                            top: `${cssTop * scale}px`,
                            left: `${cssLeft * scale}px`,
                            width: `${cellWidth * scale}px`,
                            height: `${rect.height * scale}px`,
                        },
                    });
                }
                fieldData.push(combedFieldData);
            }
        } else {
            // Lógica original para campos de texto no peinados
            const cssTop = pageHeight - rect.y - rect.height;
            const cssLeft = rect.x;

            const textStyle = ruledLayout
                ? getRuledTextareaStyle(
                      getRuledTextBox(ruledLayout, rect, getWidgetBorderWidth(widget)),
                      rect,
                      parseDefaultAppearance(field).fontSize,
                      scale
                  )
                : undefined;

            fieldData.push({
                pageIndex,
                maxLength: field instanceof PDFTextField ? field.getMaxLength() : undefined,
                isMultiline: field instanceof PDFTextField ? field.isMultiline() : undefined,
                textStyle,
                isCell: false,
                pdfCoords: rect,
                cssCoords: {
                    top: `${cssTop * scale}px`,
                    left: `${cssLeft * scale}px`,
                    width: `${rect.width * scale}px`,
                    height: `${rect.height * scale}px`,
                },
            });
        }
    });

    return fieldData;
};
